import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';
export const ResourceService = {
    getResourceDetails,
    getCCDetails,
    addCCDetails,
    getInvoicesList,
    getInvoiceDetails,
    sendOtp,
    sendProfileEmailOtp,
    sendProfileOtp,
    updateCCDetails,
    fetchPendingCharges,
    reactivateAccount,
    getSubscriptionDetails,
    getStripeKey,
    fecthAmountToResize,
    resizePayment,
    resizePayment_v2,
    getYearResourcesDetails,
    getResourceDetailsByResource,
    verifySubAccOtp,
    verifyAccOtp,
    sendEmailOtp,
    getPageInfo,
    verifyOtp,
};


function getUserId() {
    return localStorage.getItem('userId');
}

async function getResourceDetailsByResource(resourceId) {
    return await axiosInstance.get(`/resource/prepaidresources/` + getUserId() + "?resourceId=" + resourceId, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getYearResourcesDetails() {
    return await axiosInstance.get(`/prepaid/` + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getResourceDetails(monthyear) {
    return await axiosInstance.get(`/resource/` + monthyear + '/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getCCDetails() {
    return await axiosInstance.get(`/resource/` + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getStripeKey() {
    return await axiosInstance.get(`/resource/stripe_public/` + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function addCCDetails(ccDetails) {
    return await axiosInstance.post(`/resource/add/cc`, ccDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}


async function getInvoicesList() {
    return await axiosInstance.get(`/resource/invoice/list/` + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}
async function getInvoiceDetails(invoiceId) {
    return await axiosInstance.get(`/resource/invoice/` + invoiceId + "/" + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function getSubscriptionDetails() {
    return await axiosInstance.get(`/resource/getsubscription/` + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(error => {
            return false;
        });
}

async function getPageInfo() {
    return await axiosInstance.get(`/2fa/page/` + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function sendOtp(otpDetails, event) {
    let path = '/resource/send/otp';
    if(event !== undefined) path = path + '?captcha=' + event;
    return await axiosInstance.post(path, otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}
async function sendEmailOtp(otpDetails, event) {
    return await axiosInstance.post('/resource/send/otp?captcha=' + event + '&isEmail=true', otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(error => {
            return Promise.reject(error);
        });
}
async function sendProfileOtp(otpDetails, event) {
    let path = '/resource/send/profile/otp';
    if(event !== undefined) path = path + '?captcha=' + event;
    return await axiosInstance.post(path, otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}
async function sendProfileEmailOtp(otpDetails, event) {
    return await axiosInstance.post('/resource/send/profile/otp?captcha=' + event + '&isEmail=true', otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}


async function verifySubAccOtp(otpDetails, type) {
    return await axiosInstance.post(`/resource/verify/sub-acc-otp/` + getUserId() + `?type=` + type, otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return Promise.reject(error);
        });
}

async function verifyAccOtp(otpDetails, type) {
    return await axiosInstance.post(`/resource/verify/acc-otp/` + getUserId() + `?type=` + type, otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return Promise.reject(error);
        });
}

async function verifyOtp(otpDetails, type) {
    return await axiosInstance.post(`/resource/verify/otp/` + getUserId(), otpDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return Promise.reject(error);
        });
}

async function updateCCDetails(ccDetails) {
    return await axiosInstance.post(`/resource/up/cc`, ccDetails, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

async function fetchPendingCharges() {
    return await axiosInstance.get(`/resource/fetchPendingCharges`, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(err => {
        throw err;
    });
}

async function reactivateAccount(ccDetails) {
    return await axiosInstance.post(`resource/reactivate`, ccDetails, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(err => {
        throw err;
    });
}

async function fecthAmountToResize(data) {

    return await axiosInstance.post(`/resize/fecthAmountForResize/` + getUserId(), data, axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(error => {
            return false;
        });
}

function resizePayment(resizeDto) {
    let requestBody = JSON.stringify(resizeDto);
    return fetch(API_HOST + '/resize/resizeamount/' + getUserId(),
        {
            credentials: 'include',
            timeout: 100000,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
            },
            body: requestBody
        }
    ).then((response) =>
        response.json())
        .then((resp) => {
            return resp;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}

async function resizePayment_v2(resizeDto) {
    let requestBody = JSON.stringify(resizeDto);
    let config = axiosRequestWithAuth;
    config['timeout'] = 100000;
    return await axiosInstance.post(`/resize/resizeamount/` + getUserId(), requestBody, config).then(resp => {
        return resp.data;
    }).catch(err => {
        return false;
    });
};

export default ResourceService;
